export default function (attachments) {
  return attachments.map(attachment => convertToMarkdownImage(attachment))
}

function convertToMarkdownImage(attachment) {
  return `![${attachment.name}](${attachment.url} "${attachment.name}")\n`
}
